import axios from "axios"

export const notificationApiGetDataStatus = async ({
    signal
}) => {

    try {
        
        const res = await axios(
            {
                method:'get', 
                url: `${process.env.REACT_APP_STATUS_API_URL}?populate=*&filters[$and][0][has_issues][$eq]=true`,
                headers: {},
                signal
            },
        )

        const data = await res.data
        console.log(data)
        if (data && data.data) {
            return {
                fapro: {
                    success: true,
                    code: data.code,
                    message: data.message,
                    status: data.status,
                    data: data.data
                }
            }
        } else {
            return {
                fapro: {
                    success: false,
                    code: 400,
                    message: "",
                    status: 0,
                    data: null
                }
            }
        }

    } catch (err) {
        if (err.response) {
            return {
                fapro: {
                    success: false,
                    code: err.response.data.code,
                    message: err.response.data.message,
                    status: err.response.data.status,
                    data: null
                }
            }
        } else {
            return {
                fapro: {
                    success: false,
                    code: 500,
                    message: err.message || 'Opps! Algo salió mal, intente más tarde.',
                    status: 'error',
                    data: null
                }
            }
        }
    }
}
